import { signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { effect, inject } from '@angular/core';
import { BaseState, withCrudOperations } from '../crud.state';
import { History } from '../../models/history';
import { withHistorySelectors } from './history.selectors';
import { HistoryService } from '../../services/history/history.service';
import { ActiveUserStore } from '../user/active-user.state';

export type HistoryState = BaseState<History>;

export const initialState: HistoryState = {
  items: {},
  loading: false,
  initialized: false,
  itemsLoaded: false,
  selectedId: '',
  selection: [],
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'History',
  entityLabel: 'Verlauf',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const HistoryStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<History>(HistoryService),
  withHistorySelectors(),
  withMethods(store => ({})),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // Same early-construction issue as BookmarkStore/StoryStore/etc:
      // any store using withLogging() (topic/bookmark/story/bookmarkCategory
      // among them) field-injects THIS store from its own onInit, and those
      // are reachable pre-login via the ToolOverlayComponent ->
      // RoutingService -> TopicHelperService chain. A one-shot call here
      // used to at least fire the request (with an empty commune); since
      // crud.state.ts now refuses to send commune-scoped requests without
      // a commune id, that one-shot call silently no-ops and never
      // retried. Watch reactively instead.
      // Only for logged-in users outside the public Atlas: the public Atlas
      // sets a commune from the slug (also for guests), and /api/history
      // requires auth - a 401 there opens the "Login abgelaufen" dialog for
      // every visitor, and a logged-in user viewing another commune's public
      // Atlas gets logged out (X-Commune-ID no longer matches the token).
      effect(
        () => {
          const context = activeUserStore.context();
          const isPublicContext =
            context === 'atlasExternal' || context === 'guestView';
          if (
            activeUserStore.isLoggedIn() &&
            activeUserStore.commune() &&
            !isPublicContext
          ) {
            store.loadAllItemsByPromise();
          }
        },
        { allowSignalWrites: true }
      );
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
